// extracted by mini-css-extract-plugin
export default {"contactBox":"style_contactBox__OQBZi","contactMain":"style_contactMain__lOGAT","title":"style_title__EREDp","infoBox":"style_infoBox__NFG-o"};